export default "__VITE_ASSET__CEBy8Bs0__"